import * as React from "react";
import { Button, Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

interface Props {
  onClick: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  viewInstitutionButton: {
    position: "absolute",
    right: theme.spacing(1),
    textTransform: "none",
    margin: "0px 16px 10px 0px",
  },
}));

export default function ViewInstitutionModalSubtitle({ onClick }: Props) {
  const classes = useStyles();
  return (
    <Button
      id="view-institution-details-button"
      onClick={onClick}
      className={classes.viewInstitutionButton}
      variant="outlined"
      color="primary"
      size={"small"}
    >
      View Institution Details
    </Button>
  );
}
